import React from 'react';
import { Link } from 'react-router-dom';
import './Pages/PagesCss/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: "Home", path: "/", isExternal: false },
    { name: "About Us", path: "https://d-techstudios/about", isExternal: true },
    { name: "Contact Us", path: "https://d-techstudios/contact", isExternal: true },
    { name: "Our Services", path: "https://www.d-techstudios.com/Services", isExternal: true },
    { name: "Sitemap", path: "/sitemap.xml", isExternal: true },
  ];

  const mathCategories = [
    { name: "Basic Math", path: "/AdditionCalculator" },
    { name: "Geometry", path: "/AreaCircle" },
    { name: "Algebra", path: "/LinearEquationSolver" },
    { name: "Trigonometry", path: "/SineCalculator" },
    { name: "Calculus", path: "/DerivativeCalculator" },
    { name: "Statistics", path: "/MeanCalculator" },
    { name: "Financial", path: "/PresentValueCalculator" },
    { name: "Converters", path: "/LengthConverter" },
    { name: "Advanced Math", path: "/FibonacciCalculator" },
  ];

  const advancedCategories = [
    { name: "D-TechStudios", path: "https://www.d-techstudios.com/" },
    { name: "CryptoMux", path: "https://cryptomux.com/" },
    { name: "NoobToBull", path: "https://www.noobtobull.com/" },
    { name: "CreditsIQ", path: "https://www.creditsiq.com/" },
    { name: "Font-Max", path: "https://font-max.com/" },
    { name: "AfterTaxPay", path: "https://aftertaxpay.net/" },
    { name: "AiPicks", path: "https://www.aipicks.org/" },
  ];

  const legalCategories = [
    { name: "Privacy Policy", path: "https://www.d-techstudios.com/PrivacyPolicy" },
    { name: "Terms & Conditions", path: "https://www.d-techstudios.com/TermsConditions" },
    { name: "Content Policy", path: "https://www.d-techstudios.com/ContentPolicy" },
    { name: "Cookie Policy", path: "https://www.d-techstudios.com/CookiePolicy" },
    { name: "Disclaimer", path: "https://www.d-techstudios.com/Disclaimer" },
  ];

  const socialMediaLinks = [
    { name: "Twitter", icon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.59-6.64 7.59H.47l8.6-9.83L0 1.154h7.594l5.243 6.932 6.064-6.932zM17.61 20.644h2.04L6.486 3.24H4.298L17.61 20.644z" />
    </svg>
  ), path: "https://x.com/D_TechStudios" },
    { name: "LinkedIn", icon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM0 8h5v16H0V8zm7.5 0h4.8v2.2h.07c.67-1.27 2.3-2.6 4.73-2.6 5.06 0 6 3.33 6 7.66V24h-5V16.2c0-1.86-.04-4.26-2.6-4.26-2.6 0-3 2.03-3 4.12V24h-5V8z" />
    </svg>
  ), path: "https://www.linkedin.com/company/d-tech-studios?trk=public_post_follow-view-profile" },
    { name: "FaceBook", icon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.675 0h-21.35C.597 0 0 .597 0 1.326v21.348C0 23.403.597 24 1.326 24h11.495v-9.294H9.691V11.01h3.13V8.41c0-3.1 1.894-4.788 4.659-4.788 1.325 0 2.464.099 2.795.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.764v2.31h3.587l-.467 3.696h-3.12V24h6.116C23.403 24 24 23.403 24 22.674V1.326C24 .597 23.403 0 22.675 0z" />
    </svg>
  ), path: "https://www.facebook.com/people/D-Tech-Studios/61556107977536/" },
    { name: "Instagram", icon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.343 3.608 1.318.975.975 1.256 2.242 1.318 3.608.058 1.266.07 1.646.07 4.84s-.012 3.574-.07 4.84c-.062 1.366-.343 2.633-1.318 3.608-.975.975-2.242 1.256-3.608 1.318-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.343-3.608-1.318-.975-.975-1.256-2.242-1.318-3.608C2.175 15.574 2.163 15.194 2.163 12s.012-3.574.07-4.84c.062-1.366.343-2.633 1.318-3.608.975-.975 2.242-1.256 3.608-1.318 1.266-.058 1.646-.07 4.84-.07zM12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zm0 10.162a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0z" />
    </svg>
  ), path: "https://www.instagram.com/d_techstudios/" }
  ];

  // Helper function to render links
  const renderLink = (link, index, isExternal = false) => {
    if (isExternal || link.isExternal) {
      return (
        <a 
          href={link.path} 
          className="footer-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {link.name}
        </a>
      );
    } else {
      return (
        <Link to={link.path} className="footer-link">
          {link.name}
        </Link>
      );
    }
  };

  return (
    <footer className="footer">
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            
            {/* Brand Section */}
            <div className="footer-brand">
              <div className="mobile-logo">
              <span>D-Tech</span>
              <div className="parallelogram">
                <span>Studios</span>
              </div>
            </div>
              <p className="footer-description">
                Your comprehensive math calculator suite offering 350+ tools for 
                students, teachers, and professionals. Fast, accurate, and completely free.
              </p>
              
              {/* Social Media Links */}
              <div className="footer-social">
                <h4 className="social-title">Follow Us</h4>
                <div className="social-links">
                  {socialMediaLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.path}
                      className="social-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={social.name}
                    >
                      <span className="social-icon">{social.icon}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Two Column Layout for Sections */}
            <div className="footer-sections-grid">
              {/* Left Column */}
              <div className="footer-column">
                <div className="footer-section">
                  <h4 className="footer-title">Navigation</h4>
                  <ul className="footer-links">
                    {quickLinks.map((link, index) => (
                      <li key={index}>
                        {renderLink(link, index)}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="footer-section">
                  <h4 className="footer-title">Tools</h4>
                  <ul className="footer-links">
                    {mathCategories.map((category, index) => (
                      <li key={index}>
                        <Link to={category.path} className="footer-link">
                          {category.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Right Column */}
              <div className="footer-column">
                <div className="footer-section">
                  <h4 className="footer-title">Legal</h4>
                  <ul className="footer-links">
                    {legalCategories.map((category, index) => (
                      <li key={index}>
                        <a 
                          href={category.path} 
                          className="footer-link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {category.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="footer-section">
                  <h4 className="footer-title">Our Platforms</h4>
                  <ul className="footer-links">
                    {advancedCategories.map((category, index) => (
                      <li key={index}>
                        <a 
                          href={category.path} 
                          className="footer-link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {category.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <p>&copy; {currentYear} D-Tech Studios. All rights reserved.</p>
            </div>
            <div className="footer-legal">
  <a href="https://www.d-techstudios.com/PrivacyPolicy" className="legal-link" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
  <a href="https://www.d-techstudios.com/TermsConditions" className="legal-link" target="_blank" rel="noopener noreferrer">Terms of Service</a>
  <a href="https://d-techstudios/contact" className="legal-link" target="_blank" rel="noopener noreferrer">Contact</a>
</div>
          </div>
        </div>
      </div>

      {/* Footer Glow Effect */}
      <div className="footer-glow"></div>
    </footer>
  );
};

export default Footer;